import { AppProviders } from './providers/AppProviders';
import { AppRouter } from './router';
import { useAuthBootstrap } from '@shared/hooks/useAuthBootstrap'

export default function App() {
  const isReady = useAuthBootstrap();

  if (!isReady) {
    return null
  }

  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
}
